import { InterestCheck } from './InterestCheck';
import { useInterests } from '@/hooks/useInterests';
import type { CommunityClub } from '@/lib/communityClubs';

export function ClubCard({ club, embedded = false }: { club: CommunityClub; embedded?: boolean }) {
  const { hasInterest, toggleInterest } = useInterests();
  const checked = hasInterest(club.interestId);

  return (
    <div className={embedded ? undefined : 'card'} id={club.id} style={embedded ? undefined : { marginTop: 8 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
        <div style={{ minWidth: 0 }}>
          {embedded ? null : <h2 style={{ fontSize: 16, margin: 0 }}>{club.name}</h2>}
          <p style={{ fontSize: 14, lineHeight: 1.5, marginTop: embedded ? 0 : 6 }}>{club.summary}</p>
        </div>
        <InterestCheck
          checked={checked}
          label={club.name}
          onToggle={() => toggleInterest(club.interestId)}
        />
      </div>
      <ul style={{ fontSize: 14, lineHeight: 1.6, paddingLeft: 18, marginTop: 10 }}>
        {club.details.map((line) => (
          <li key={line.slice(0, 40)}>{line}</li>
        ))}
      </ul>
      <p style={{ fontSize: 13, color: 'var(--color-ink-muted)', marginTop: 10, lineHeight: 1.5 }}>
        {club.joinNote}
      </p>
      <div className="action-row" style={{ marginTop: 10 }}>
        {club.phone && (
          <a className="action-btn" href={`tel:${club.phone}`}>
            {club.joinLabel}
          </a>
        )}
        {club.href && !club.phone && (
          <a className="action-btn" href={club.href}>
            {club.joinLabel}
          </a>
        )}
        {club.href && club.phone && (
          <a className="action-btn" href={club.href}>
            Club page
          </a>
        )}
      </div>
      <p style={{ fontSize: 12, color: 'var(--color-ink-muted)', marginTop: 10, lineHeight: 1.45 }}>
        {club.sourceNote}
      </p>
    </div>
  );
}
